import React, { useState } from "react";
import "./App.css";
import Header from "./components/Header";
import Categories from "./components/Categories";
import MenuItems from "./components/MenuItems";
import Footer from './components/Footer';

// بيانات وهمية
const categories = [
  { id: 1, name: "DONNER", icon: "/icons/danner.webp" },
  { id: 2, name: "SHAWARMA", icon: "/icons/shawarma.webp" },
  { id: 3, name: "BOWLS", icon: "/icons/bowls.webp" },
  { id: 4, name: "BOX", icon: "/icons/box.webp" },
  { id: 5, name: "ENFANT", icon: "/icons/enfant.webp" },
];

const items = [
  { id: 1, categoryId: 1, name: "Kebab Viande", price: 400, img: "/items/danner01.webp" },
  { id: 2, categoryId: 1, name: "Kebab Poulet", price: 350, img: "/items/danner01.webp" },
  { id: 3, categoryId: 1, name: "Kebab Poulet / Lg / Feta", price: 400, img: "/items/danner01.webp" },
  { id: 4, categoryId: 1, name: "Kebab Boeuf", price: 400, img: "/items/danner01.webp" },
  { id: 5, categoryId: 1, name: "Camembert Boeuf", price: 450, img: "/items/01.webp" },
  { id: 6, categoryId: 1, name: "Camembert Poulet", price: 400, img: "/items/01.webp" },
  { id: 7, categoryId: 1, name: "Picanto Boeuf", price: 450, img: "/items/02.webp" },
  { id: 8, categoryId: 1, name: "Picanto Poulet / Pimant", price: 400, img: "/items/02.webp" },


  { id: 9, categoryId: 2, name: "Poulet L", price: 200, img: "/items/03.webp" },
  { id: 10, categoryId: 2, name: "Poulet XL", price: 300, img: "/items/03.webp" },
  { id: 11, categoryId: 2, name: "Viande L", price: 300, img: "/items/03.webp" },
  { id: 12, categoryId: 2, name: "Viande XL", price: 400, img: "/items/03.webp" },


  { id: 13, categoryId: 3, name: "Riz Boeuf", price: 600, img: "/items/04.webp" },
  { id: 14, categoryId: 3, name: "Riz Poulet", price: 450, img: "/items/04.webp" },
  { id: 15, categoryId: 3, name: "Melange Viandes", price: 500, img: "/items/04.webp" },
  { id: 16, categoryId: 3, name: "Frites Poulet", price: 400, img: "/items/41.webp" },
  { id: 17, categoryId: 3, name: "Frites Boeuf", price: 500, img: "/items/41.webp" },


  { id: 18, categoryId: 4, name: "Poulet PM", price: 900, img: "/items/05.webp" },
  { id: 19, categoryId: 4, name: "Poulet GM", price: 1500, img: "/items/05.webp" },
  { id: 20, categoryId: 4, name: "Boeuf PM", price: 1100, img: "/items/05.webp" },
  { id: 21, categoryId: 4, name: "Boeuf GM", price: 1900, img: "/items/06.webp" },

    { id: 22, categoryId: 5, name: "Shawarma-Frite-Fita jus", price: 200, img: "/items/07.webp" },
];

function App() {
  const [selectedCategory, setSelectedCategory] = useState(categories[0].id);

  const filteredItems = items.filter(item => item.categoryId === selectedCategory);

  return (
    <div className="App">
      <Header />
      <Categories
        categories={categories}
        selected={selectedCategory}
        onSelect={setSelectedCategory}
      />
      <MenuItems items={filteredItems} />
      <Footer />
    </div>
  );
}

export default App;
